import { render, staticRenderFns } from "./NewsLabels.vue?vue&type=template&id=d7c7f938&scoped=true"
import script from "./NewsLabels.vue?vue&type=script&lang=js"
export * from "./NewsLabels.vue?vue&type=script&lang=js"
import style0 from "./NewsLabels.vue?vue&type=style&index=0&id=d7c7f938&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7c7f938",
  null
  
)

export default component.exports